import { IApplicationState } from '../../types/redux';
import { getFilters } from './getFilters';

export function getApartmentsWithDecoration(state: IApplicationState) {
  const filters = getFilters(state);

  return filters.apartmentsWithDecoration;
}
